import { useContext } from "react";
import { GlobalSnackbarContext } from "../contexts/GlobalSnackbarContext";

// ----------------------------------------------------------------------

const useGlobalSnackbar = () => useContext(GlobalSnackbarContext);

export default useGlobalSnackbar;
